module.exports = __webpack_public_path__ + "static/img/select-img6.6b52ce1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/select-img6.png
// module id = h341
// module chunks = 1